<div class="grid p-3" *ngIf="paymentPlanned as vm">
    <div class="col-12">

        <!-- ================= CONTRACT ================= -->
        <div class="mb-2 border-round-md surface-0 p-3">
            <div class="flex justify-content-between align-items-center gap-3 px-1">

                <div class="flex align-items-center gap-3">
                    <!-- icon box -->
                    <div class="flex-shrink-0 border-round"
                         style="width:36px;height:36px;background:#f3f4f6;border-radius:8px;">
                    </div>

                    <div class="flex flex-column">
                        <div class="flex align-items-center gap-2">
                <span class="font-bold" style="color:#111827;">
                  {{ vm.contract?.productName }}
                </span>

                            @if (vm.contract?.contractIdentifier) {
  <span class="font-bold" style="color:#111827;" >
                  ({{ vm.contract?.contractIdentifier }})
                </span>
}
                        </div>

                        <div style="font-size:0.85rem;color:#6b7280;">
                            {{ vm.contract?.startDate | date:'dd. MM.yyyy' }} -
                            {{ vm.contract?.endDate   | date:'dd. MM.yyyy' }}
                        </div>
                    </div>
                </div>

                <div class="font-bold white-space-nowrap" style="color:#111827;">
                    €{{ vm.prices?.[0]?.priceGross | number:'1.2-2' }}
                </div>

            </div>
        </div>

        <!-- ================= CONTRACT PAYMENT ACCOUNT ================= -->
        <p-accordion class="bm-accordion" value="0">
            <p-accordion-panel value="0">
                <p-accordion-header>
                    <div class="text-xl">
                        <div class="flex gap-3 align-items-start w-full md:w-auto">

                            <!-- ICON -->
                            <div class="w-2rem h-2rem bg-red-500 text-white border-round-md flex align-items-center justify-content-center">
                                <i class="pi pi-building"></i>
                            </div>

                            <!-- TEXT BLOCK -->
                            <div class="flex flex-column gap-1">

                                <div class="flex justify-content-between gap-2 align-items-center">
                                   <div class="font-bold text-800">{{ vm.paymentAccounts?.[selectedPaymentAccountIndex]?.bankAccountName }}</div>
<!--                                    <span class="text-green-600 text-sm"> (01.10.2025)</span>-->
                                </div>

                                <div class="text-sm text-600 font-normal">
                                    {{ vm.paymentAccounts?.[selectedPaymentAccountIndex]?.iban }}
                                </div>

                                <div class="text-sm text-600 mt-1 white-space-nowrap font-normal">
                                    {{ vm.paymentAccounts?.[selectedPaymentAccountIndex]?.paymentMethod }}
                                    |
                                    {{ vm.paymentAccounts?.[selectedPaymentAccountIndex]?.startDate | date:'dd. MM.yyyy' }}
                                    –
                                    {{ vm.paymentAccounts?.[selectedPaymentAccountIndex]?.endDate
                                    ? (vm.paymentAccounts?.[selectedPaymentAccountIndex]?.endDate | date:'dd. MM.yyyy')
                                    : ''
                                    }}
                                </div>

                            </div>
                        </div>
                    </div>
                </p-accordion-header>

                <p-accordion-content>
                    <div class="grid">
                        <div class="col-12 sm:col-12 md:col-6 lg:col-6"
                             *ngFor="let acc of vm.paymentAccounts; let i = index">

                            <div class="flex flex-column sm:flex-column md:flex-row align-items-start md:align-items-center gap-3 cursor-pointer border-1 surface-border border-round-lg surface-0"
                                 style="padding:1.1rem 1.25rem;"
                                 [ngClass]="{'shadow-none': i === selectedPaymentAccountIndex}"
                                 (click)="selectPaymentAccount(i)">

                                <div class="w-2rem h-2rem bg-red-500 text-white border-round-md flex align-items-center justify-content-center">
                                    <i class="pi pi-building"></i>
                                </div>

                                <div class="flex flex-column min-w-0 w-full">
                                    <div class="font-semibold" style="color:#1f2937;">
                                        {{ acc.bankAccountName }}
                                    </div>

                                    <div class="text-sm text-500 break-all">
                                        {{ acc.iban }}
                                    </div>

                                    <div class="text-xs flex flex-column sm:flex-column md:flex-row md:align-items-center gap-1 md:gap-0"
                                         style="color:#6b7280;">
                                        {{ acc.paymentMethod }}
                                        <span class="inline-block" style="width:12px;"></span>
                                        {{ acc.startDate | date:'dd. MM.yyyy' }}
                                        &nbsp;|&nbsp;
                                        {{ acc.endDate ? (acc.endDate | date:'dd. MM.yyyy') : '-' }}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </p-accordion-content>
            </p-accordion-panel>
        </p-accordion>


        <!-- ================= CONTRACT PRICE ================= -->
        <div class="my-2">
            <p-card styleClass="surface-0 border-1 surface-border border-round shadow-none">

                <!-- HEADER -->
                <div class="flex justify-content-between align-items-center cursor-pointer px-3"
                     (click)="togglePriceHistory()">

                    <div class="font-bold text-800 text-xl">
                        Contract Price ({{ vm.prices?.[0]?.priceFrequencyName }})
                    </div>

                    <div class="flex align-items-center gap-3" style="line-height:1;">
            <span class="font-bold">
              {{ vm.prices?.[0]?.priceGross | number:'1.2-2' }}
                {{ vm.prices?.[0]?.currency }}
            </span>

                        <i class="pi"
                           [ngClass]="showPriceHistory ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                    </div>
                </div>

                <!-- TABLE -->
                <div class="mt-3" *ngIf="showPriceHistory">
                    <p-table [value]="vm.prices" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr style="background:#f3f3f3;">
                                <th style="background:#f3f3f3;padding:0.75rem;font-weight:600;color:#111827;border-top:1px solid #d1d1d3;border-bottom:1px solid #cacacc;">
                                Effective From
                                </th>
                                <th style="background:#f3f3f3;padding:0.75rem;font-weight:600;color:#111827;border-top:1px solid #d1d1d3;border-bottom:1px solid #cacacc;">
                                    Effective To
                                </th>
                                <th style="background:#f3f3f3;padding:0.75rem;font-weight:600;color:#111827;border-top:1px solid #d1d1d3;border-bottom:1px solid #cacacc;">
                                    Monthly Price
                                </th>
                                <th style="background:#f3f3f3;padding:0.75rem;font-weight:600;color:#111827;border-top:1px solid #d1d1d3;border-bottom:1px solid #cacacc;">
                                    Reason
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-p>
                            <tr>
                                <td style="padding:0.75rem 1.5rem;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                    {{ p.startDate | date:'dd MMM yyyy' }}
                                </td>
                                <td style="padding:0.75rem 1.5rem;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                    {{ p.endDate ? (p.endDate | date:'dd MMM yyyy') : '---' }}
                                </td>
                                <td style="padding:0.75rem 1.5rem;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                    {{ p.priceGross | number:'1.0-0' }} {{ p.currency }}
                                </td>
                                <td style="padding:0.75rem 1.5rem;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                    {{ p.reason }}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

            </p-card>
        </div>

        <!-- Hint for a month inside a payment suspension: tag + reason (used by the Inkasso table) -->
        <ng-template #suspensionHint let-mark>
            <p-tag value="Beitrag ausgesetzt" severity="warn"></p-tag>
            @if (mark.reasonName) {
                <span class="font-semibold text-800">{{ mark.reasonName }}</span>
            }
        </ng-template>

        <!-- ================= INKASSO ================= -->
        <p-card styleClass="surface-0 border-1 surface-border border-round shadow-none">
            <h4 class="mb-3">Inkasso</h4>

            <p-table [value]="vm.rows" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:20%;background:#f3f3f3;padding:0.75rem 1.5rem;font-weight:600;color:#111827;border-top:1px solid #d1d1d3;border-bottom:1px solid #cacacc;">
                            Datum
                        </th>
                        <th style="width:20%;background:#f3f3f3;padding:0.75rem 1.5rem;font-weight:600;color:#111827;border-top:1px solid #d1d1d3;border-bottom:1px solid #cacacc;">
                            Beschreibung
                        </th>
                        <th class="text-right" style="width:20%;background:#f3f3f3;padding:0.75rem 1.5rem;font-weight:600;color:#111827;border-top:1px solid #d1d1d3;border-bottom:1px solid #cacacc;white-space:nowrap;">
                            Forderung
                        </th>
                        <th class="text-right" style="width:20%;background:#f3f3f3;padding:0.75rem 1.5rem;font-weight:600;color:#111827;border-top:1px solid #d1d1d3;border-bottom:1px solid #cacacc;white-space:nowrap;">
                            Tilgung
                        </th>
                        <th class="text-right" style="width:20%;background:#f3f3f3;padding:0.75rem 1.5rem;font-weight:600;color:#111827;border-top:1px solid #d1d1d3;border-bottom:1px solid #cacacc;white-space:nowrap;">
                            Saldo
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>

                    @if (row.kind === 'suspendedMonth') {
                        <!-- Month inside a payment suspension: no Sollstellung, the marker says why -->
                        <tr class="bg-yellow-50">
                            <td class="py-2 px-4 border-bottom-1 surface-border text-800 white-space-nowrap">
                                {{ row.date | date:'dd.MM.yyyy' }}
                            </td>

                            <td class="py-2 px-4 border-bottom-1 surface-border" colspan="4">
                                <div class="flex flex-wrap align-items-center gap-2">
                                    <ng-container *ngTemplateOutlet="suspensionHint; context: {$implicit: row.suspension}"></ng-container>
                                    <span class="text-sm text-600">
                                        Keine Sollstellung in diesem Monat (Aussetzung
                                        {{ row.suspension.startDate | date:'dd.MM.yyyy' }}
                                        bis
                                        {{ row.suspension.endDate | date:'dd.MM.yyyy' }})
                                    </span>
                                </div>
                            </td>
                        </tr>
                    } @else {
                        @let e = row.entry;
                        <tr>
                            <td style="padding:0.75rem 1.5rem;color:#111827;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                {{ e.dueDate | date:'dd.MM.yyyy' }}
                            </td>

                            <td style="padding:0.75rem 1.5rem;color:#111827;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                {{ e.plannedTypeName }}
                                @if (row.suspension) {
                                    <!-- Entry due inside a suspended month -->
                                    <span class="inline-flex align-items-center gap-2 ml-2">
                                        <ng-container *ngTemplateOutlet="suspensionHint; context: {$implicit: row.suspension}"></ng-container>
                                    </span>
                                }
                            </td>

                            <!-- Forderung -->
                            @if (e.status === 'DEBIT') {
                                <td class="text-right font-semibold"
                                    style="padding:0.75rem 1.5rem;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                    -{{ e.amount | number:'1.2-2' }} {{ e.currency }}
                                </td>
                            }
                            @if (e.status !== 'DEBIT') {
                                <td class="text-right"
                                    style="padding:0.75rem 1.5rem;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                    &nbsp;
                                </td>
                            }

                            <!-- Tilgung -->
                            @if (e.status === 'CREDIT') {
                                <td class="text-right font-semibold"
                                    style="padding:0.75rem 1.5rem;border-bottom:1px solid #e5e7eb;color:#2e7d32;white-space:nowrap;">
                                    +{{ e.amount | number:'1.2-2' }} {{ e.currency }}
                                </td>
                            }
                            @if (e.status !== 'CREDIT') {
                                <td class="text-right"
                                    style="padding:0.75rem 1.5rem;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                    &nbsp;
                                </td>
                            }

                            <!-- Saldo -->
                            <td class="text-right"
                                style="padding:0.75rem 1.5rem;color:#111827;border-bottom:1px solid #e5e7eb;white-space:nowrap;">
                                {{ e.remainingAmount | number:'1.2-2' }} {{ e.currency }}
                            </td>
                        </tr>
                    }

                </ng-template>
            </p-table>
        </p-card>

    </div>
</div>